import Auth from '@/packages/auth/Auth';
import {initLang} from "../../lang";

Vue.use(Auth);

export default {
    mixins: {
        global
    },
    state: {
        signupSuccess: false
    },

    actions: {
        login(context, payload) {
            return context
                .dispatch('post', {
                    url: `${api}login`,
                    data: {
                        ...payload.user,
                        client_id: process.env.VUE_APP_LUDUM_CLIENT_ID,
                        client_secret: process.env.VUE_APP_LUDUM_CLIENT_SECRET,
                        grant_type: 'password'
                    }
                })
                .then(response => {
                    const { accessToken } = response.data;
                    // Save token to cookies for 30 days
                    accessToken && Vue.auth.setToken(accessToken, '30D');
                    if(localStorage.getItem('language') !== response.data.user.preferred_language) {
                        Vue.cookie.set('language', response.data.user.preferred_language);
                        localStorage.setItem('language', response.data.user.preferred_language);
                        initLang();
                    }
                    context.dispatch('manageSelectedLanguage');

                    return response;
                });
        },

        manageSelectedLanguage() {
            if (!localStorage.getItem('language') || !(Vue.cookie && Vue.cookie.get('language'))) {
                Vue.cookie.set('language', 'en');
                localStorage.setItem('language', 'en');
            }
        },

        signup(context, payload) {
            // if we dispatch a user with an id, that means
            // they're coming from vendor. In that case, account is
            // already registered but inactive and we need to update
            // the user, not create one
            const url = payload.id ? 'account-details' : 'register';
            return context.dispatch('post', {
                url: `${api}${url}`,
                data: payload
            });
        }
    }
};
